import { useContext } from 'react';
import { columnSelectContext } from './columnSelectContext';
/**
 * This hook gets you access to the data of the surrounding
 * column select provider, such as the currently selected columns.
 *
 * @example // getting selected columns
 * const { selectedColumnList } = useColumnSelect();
 */
export const useColumnSelect = () => useContext(columnSelectContext);
